module.exports = __webpack_public_path__ + "img/drone-at-damuls.cafbc53c.jpg";